(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/models/result-month.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/models/result-month.js');

'use strict';

const {
  getDrawResultsDatepicker
} = svs.tur.apiCaller.drawgames;
svs.numbergames.results.models.ResultMonth = svs.numbergames.core.NumbergamesModel.extend({
  defaults: {
    year: undefined,
    month: undefined,
    dates: {},
    productId: ''
  },
  async fetchAction(options) {
    const {
      month,
      year,
      productId
    } = this.attributes;
    const datePickerMonth = month + 1;
    const productName = svs.numbergames.productMapping.getProductName(productId).toLowerCase();
    try {
      const requests = [getDrawResultsDatepicker({
        product: productName,
        year,
        month: datePickerMonth
      })];
      if (svs.numbergames.productMapping.hasJoker(productId)) {
        requests.push(getDrawResultsDatepicker({
          product: 'joker',
          year,
          month: datePickerMonth
        }));
      }
      const [response, addonResponse] = await Promise.all(requests);
      options.success({
        datePicker: response.response,
        addonDatePicker: addonResponse === null || addonResponse === void 0 ? void 0 : addonResponse.response
      });
    } catch (error) {
      options.error(error);
    }
  },
  parse(attrs) {
    let datePicker;
    let addonDatePicker;
    if (attrs.datePicker) {
      ({
        datePicker,
        addonDatePicker
      } = attrs);
    } else if (attrs.responses) {
      [datePicker, addonDatePicker] = attrs.responses;
    } else {
      datePicker = attrs;
    }
    return {
      year: datePicker.year,
      month: datePicker.month - 1,
      dates: svs.numbergames.results.parsers.datePicker.parseDates(datePicker, addonDatePicker) || {},
      productId: svs.numbergames.productMapping.getProductId(datePicker.product)
    };
  },
  getAvailableDates() {
    const {
      year,
      month,
      dates
    } = this.attributes;
    const drawDates = [];

    for (const date in dates) {
      drawDates.push([year, month, Number(date)]);
    }
    return drawDates;
  },
  getLatestDraw() {
    const drawDates = Object.keys(this.get('dates')).sort((a, b) => a - b);
    return this.getDrawByDate(drawDates.pop());
  },
  getDrawByDate(dayOfMonth) {
    const dates = this.get('dates');
    return dates[dayOfMonth];
  }
});

 })(window);